<template>
	<div class="c-googlemapsstatic__wrapper">
		<div class="t-margin-1-bottom">
			<div class="c-googlemapsstatic__header">
				<h2 class="text-h4 heading-boarder">{{ heading }}</h2>
				<a target="_blank" :href="googleMapsUrl" v-if="hasLink">{{ linkText }}</a>
			</div>

			<div class="t-margin--1-top" v-if="hasMap">
				<div class="c-googlemapsstatic__image c-content-block">
					<img class="t-border-radius-1 t-box-shadow-1" :src="imageUrl" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "VGoogleMapsStatic",
	components: {

	},
	props: {
		imageUrl: {
			type: String,
			default: ''
		},
		googleMapsUrl: {
			type: String,
			default: ''
		},
		heading: {
			type: String,
			default: 'Hitta hit'
		},
		linkText: {
			type: String,
			default: "Visa på Google Maps"
		}
	},
	computed: {
		hasMap() {
			if (!this.imageUrl) return false;
			return this.imageUrl.trim().length > 0;
		},
		hasLink() {
			if (!this.googleMapsUrl) return false;
			return this.googleMapsUrl.trim().length > 0;
		}
	}
};
</script>
